//STUB
import { Component, ElementRef, Input, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import { CounterHeaderData } from "src/components/shared-components/class/counter-header-data";
import { SmartPaletteCounter } from "src/components/shared-components/class/smart-palette";
import { SmartComponentType } from "src/components/shared-components/enum/enumSmartComponentType";
import { ThemeService } from "src/service/theme.service";
import { IonIcon } from "@ionic/angular";
import { SmartComponentSpinnerComponent } from "../../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../../error-loading-widget/error-loading-widget.component";

@Component({
    selector: "app-counter-header",
    templateUrl: "./counter-header.component.html",
    styleUrls: [
        "./counter-header.component.scss",
        "../../../styles/shared-global.scss",
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent]
})
export class CounterHeaderComponent implements OnInit {
  private readonly _elementRef = inject(ElementRef);
  private readonly _themeService = inject(ThemeService);

  public isExpanded: boolean = false;
  public displayHeader: boolean = false;

  public isVimar: boolean = false;

  @Input("counterTypeId") displayedCounterTypeId: SmartComponentType =
    SmartComponentType.ELECTRIC;
  @Input("fullHeaderData") headerData: CounterHeaderData = null;
  @Input("smartPaletteHeader") smartPalette: SmartPaletteCounter = null;
  @Input() errorLoading: boolean = false;
  @Input() isSupervision: boolean = false;
  @Input() classImgPosition: string;
  @Input() showText: boolean;
  @Input() textColor: string;
  @Input() rotationIcon: number;
  @Input() zoom: number;

  constructor() {
    this.isVimar = this._themeService.isVimar;
  }

  ngOnInit() {
    this.applySmartPalette();
  }

  ngOnChanges() {
    if (this.headerData) {
      this.displayHeader = true;
    }
  }

  /**
   * Get icon by smart component counter type
   *
   * @returns icon path
   */
  public getIconBySmartComponentType(): string {
    switch (this.displayedCounterTypeId) {
      case SmartComponentType.COLD_WATER:
        return `assets/img${this.isVimar ? "/vimar" : ""}/counter/cold-water.svg`;
      case SmartComponentType.HOT_WATER:
        return `assets/img${this.isVimar ? "/vimar" : ""}/counter/hot-water.svg`;
      case SmartComponentType.GAS:
        return `assets/img${this.isVimar ? "/vimar" : ""}/counter/gas.svg`;
      case SmartComponentType.ELECTRIC:
        return `assets/img${this.isVimar ? "/vimar" : ""}/counter/electric.svg`;
      case SmartComponentType.DISTRIBUTOR:
        return `assets/img${this.isVimar ? "/vimar" : ""}/counter/distributor.svg`;
      case SmartComponentType.HEATING:
        return `assets/img${this.isVimar ? "/vimar" : ""}/counter/heating.svg`;
      default:
        return "";
    }
  }

  private applySmartPalette(): void {
    this._elementRef.nativeElement.style.setProperty(
      "--smart-background",
      this.smartPalette.backgroundColor
    );
    this._elementRef.nativeElement.style.setProperty(
      "--smart-color-main",
      this.smartPalette.mainLableColor
    );
    this._elementRef.nativeElement.style.setProperty(
      "--smart-color-secondary",
      this.smartPalette.secondaryLableColor
    );
  }
}
